
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zM27.3 7.628L24 8.1l.472-3.3-2.51 2.51a10.617 10.617 0 00-5.995-1.843C10.076 5.467 5.3 10.242 5.3 16.133S10.076 26.8 15.967 26.8c5.89 0 10.666-4.776 10.666-10.667 0-2.222-.68-4.286-1.843-5.995l2.51-2.51zm-5.205 14.634a8.61 8.61 0 01-6.128 2.538 8.61 8.61 0 01-6.129-2.538A8.61 8.61 0 017.3 16.133a8.61 8.61 0 012.538-6.128 8.61 8.61 0 016.129-2.538 8.6 8.6 0 015.38 1.871l-2.383 2.384a5.333 5.333 0 101.414 1.414l2.384-2.383a8.6 8.6 0 011.871 5.38 8.61 8.61 0 01-2.538 6.129zm-6.569-5.688a.997.997 0 001.414 0l1.981-1.981c.242.461.379.985.379 1.54a3.337 3.337 0 01-3.333 3.334 3.337 3.337 0 01-3.334-3.334 3.337 3.337 0 013.334-3.333c.555 0 1.079.137 1.54.379l-1.98 1.98a1 1 0 000 1.415z"}})])
          )
        }
      }
    